import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import { useNotification } from '@revenuewell/front-end-bundle';
import { FC, useEffect, useState } from 'react';
import { useInsuranceApi } from '../../../../../hooks/use-insurance-api';
import { ProviderSelectionDialog } from '../../../shared/components/provider-selection-dialog/provider-selection-dialog';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';

export interface IButtonProps {
  onSuccess: () => Promise<void>;
  disabled?: boolean;
}

export const ManuallyVerifiedButton: FC<IButtonProps> = (props) => {
  const { onSuccess, disabled } = props;
  const { showError, showSuccess } = useNotification();
  const { status, manuallyVerifyApptRequest } = useInsuranceApi();
  const { locationId, appointmentRequest, ivSummary, sendIvStatusUpdatedEvent, setIsLoading, providers } =
    useApptRequestIvStatusDialog();
  const [providerDialogOpen, setProviderDialogOpen] = useState(false);

  useEffect(() => {
    if (status.manualVerification.error) showError('Unable to perform the operation.');
  }, [status.manualVerification.error]);

  const updateInsuranceStatus = async () => {
    if (ivSummary?.idProvider) await manuallyVerifiedRequest(ivSummary.idProvider);
    else setProviderDialogOpen(true);
  };

  const manuallyVerifiedRequest = async (provId: number) => {
    setIsLoading(true);

    const success = await manuallyVerifyApptRequest(appointmentRequest!.id, locationId, provId);

    if (success) {
      showSuccess('IV status was updated successfully.');
      sendIvStatusUpdatedEvent('ManuallyVerified');
      await onSuccess();
    }

    setIsLoading(false);
  };

  const handleProviderDialogSubmit = async (selectedProviderId: number) => {
    await manuallyVerifiedRequest(selectedProviderId);
    setProviderDialogOpen(false);
  };

  const handleProviderDialogClose = () => {
    setProviderDialogOpen(false);
  };

  return (
    <Box>
      <LoadingButton
        variant="outlined"
        color="primary"
        disableElevation
        onClick={updateInsuranceStatus}
        disabled={disabled}
        loading={status.selfPayVerification.isRunning}
      >
        Manually Verified
      </LoadingButton>
      <ProviderSelectionDialog
        open={providerDialogOpen}
        title="Manually Verified - Choose Provider"
        providers={providers}
        onClose={handleProviderDialogClose}
        onSubmit={handleProviderDialogSubmit}
      />
    </Box>
  );
};
